import Icon from "../../components/ui/Icon";

export default function FirmwarePreCheck({ updateEntry, onStartUpdate }) {
  if (!updateEntry) return null;
  return (
    <div className="space-y-4">
      <section className="rounded-2xl border border-brand-navy bg-brand-purple px-4 py-3 space-y-2">
        <h3 className="text-sm font-semibold text-brand-light">Update Node: {updateEntry.nodeName}</h3>
        <p className="text-xs text-brand-light/70">
          Current:{" "}
          <span className="text-brand-light font-semibold">{updateEntry.currentVersion}</span>{" "}
          → New:{" "}
          <span className="text-brand-magenta font-semibold">{updateEntry.availableVersion}</span>
        </p>
      </section>

      <section className="rounded-2xl border border-brand-navy bg-brand-purple px-4 py-3 space-y-3">
        <div className="text-sm font-semibold text-brand-light">Pre-update Checklist</div>
        <div className="space-y-2 text-sm text-brand-light">
          {[
            { icon: "check", label: "Bluetooth connection stable" },
            { icon: "check", label: "Battery voltage: 13.1V (OK)" },
            { icon: "warning", label: "User confirmation required" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <Icon name={item.icon} className="text-brand-magenta" />
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="rounded-2xl border border-brand-magenta/60 bg-brand-magenta text-white px-4 py-3 space-y-2 shadow-lg shadow-brand-magenta/30">
        <div className="flex items-start gap-3">
          <span className="text-xl">⏻</span>
          <div className="flex flex-col gap-1 flex-1">
            <span className="text-sm font-semibold">Important Safety Notice</span>
            <p className="text-sm text-white/90">
              Do not turn off vehicle power or disconnect from the device during the update.
              This could result in an unresponsive device.
            </p>
          </div>
        </div>
      </section>

      <button
        type="button"
        onClick={onStartUpdate}
        className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition active:scale-[0.99]"
      >
        ⬇️ Start Update
      </button>
    </div>
  );
}
